import React from 'react'
import { Pressable } from 'react-native'
import Animated, { useAnimatedStyle } from 'react-native-reanimated'
import { Image } from 'expo-image'
import { colors } from '@ui/colors'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import { OutlineAnimated } from '@ui/elements/Outline'
import Skeleton from '@ui/elements/Skeleton'
import RecommendedBadge from '@ui/elements/RecommendedBadge'

import { TileOptionProps } from './types'

export default function TileOptionImage(
  props: TileOptionProps & {
    isRecommended?: boolean
    width: number
    height: number
    borderRadius?: number
  }
) {
  const {
    // title,
    // desc,
    // label,
    image,
    // cta,
    onPress,
    // backgroundGradient,
    // blurMode,
    // magicGlow,
    isRecommended,
    width,
    height,
    borderRadius = 0,
    debugContent,
  } = props
  const { animation, onPressIn, onPressOut } = useAnimatedPress()

  const scaleStyle = useAnimatedStyle(() => {
    return {
      transform: [{ scale: 1 - animation.value * 0.07 }],
    }
  })

  const outlineSize = 4

  return (
    <Pressable
      onPress={onPress}
      onPressIn={onPressIn}
      onPressOut={onPressOut}
      style={[{ width, height, borderRadius }]}
    >
      <Skeleton
        className="absolute left-0 top-0"
        style={{
          width: width,
          height: height,
          borderRadius,
          backgroundColor: colors.black10,
        }}
      />
      <Animated.View
        className="relative"
        style={[
          {
            width,
            height,
            borderRadius,
          },
          scaleStyle,
        ]}
      >
        {isRecommended && (
          <OutlineAnimated
            size={outlineSize}
            borderRadius={borderRadius}
            color={colors.violet[600]}
          />
        )}
        {!!image && (
          <Image
            contentFit="contain"
            style={{ width, height }}
            source={typeof image === 'string' ? { uri: image } : image}
          />
        )}
        {debugContent}
        {isRecommended && <RecommendedBadge />}
      </Animated.View>
    </Pressable>
  )
}
